import { _ as _objectWithoutProperties, b as _slicedToArray, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-dropdown-1-6-0{display:-webkit-inline-box;display:-webkit-inline-flex;display:-ms-inline-flexbox;display:inline-flex;position:relative;cursor:pointer}.hcr-dropdown--active-1-6-0 .hcr-dropdown__items-1-6-0{display:block}.hcr-dropdown__items-1-6-0{display:none;position:absolute;top:100%;left:50%;width:250px;max-height:none;margin-left:-125px;padding:12px 0;border-radius:5px;background:#fff;list-style:none;text-align:left;-webkit-box-shadow:0 0 12px rgba(0,0,0,.12);box-shadow:0 0 12px rgba(0,0,0,.12);overflow:visible;z-index:10;margin-top:6px}.hcr-dropdown__items--open-1-6-0{display:block}.hcr-dropdown__items-1-6-0:before{position:absolute;top:-5px;left:50%;width:0;height:0;-webkit-transform:translateX(-50%);transform:translateX(-50%);border-right:6px solid transparent;border-bottom:6px solid #fff;border-left:6px solid transparent;content:\"\"}.hcr-dropdown-item-1-6-0{margin-bottom:0;line-height:1.375em}.hcr-dropdown-item__link-1-6-0{display:block;position:relative;width:100%;padding:5px 24px;color:#444;font-size:16px;font-weight:400;text-decoration:none;cursor:pointer}.hcr-dropdown-item__link-1-6-0:hover:before,.hcr-dropdown-item__link--active-1-6-0:before{position:absolute;top:0;bottom:0;left:0;border-left:4px solid #ffad00;content:\"\"}.hcr-dropdown--top-1-6-0 .hcr-dropdown__items-1-6-0{top:auto;bottom:100%;margin-top:0;margin-bottom:6px}.hcr-dropdown--top-1-6-0 .hcr-dropdown__items-1-6-0:before{top:auto;bottom:-5px;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.hcr-dropdown--left-1-6-0 .hcr-dropdown__items-1-6-0{margin-left:-226px}.hcr-dropdown--left-1-6-0 .hcr-dropdown__items-1-6-0:before{left:100%;margin-left:-24px}.hcr-dropdown--right-1-6-0 .hcr-dropdown__items-1-6-0{margin-left:-24px}.hcr-dropdown--right-1-6-0 .hcr-dropdown__items-1-6-0:before{left:24px}",
map:{"hcr-dropdown":"hcr-dropdown-1-6-0","hcr-dropdown--active":"hcr-dropdown--active-1-6-0","hcr-dropdown__items":"hcr-dropdown__items-1-6-0","hcr-dropdown__items--open":"hcr-dropdown__items--open-1-6-0","hcr-dropdown-item":"hcr-dropdown-item-1-6-0","hcr-dropdown-item__link":"hcr-dropdown-item__link-1-6-0","hcr-dropdown-item__link--active":"hcr-dropdown-item__link--active-1-6-0","hcr-dropdown--top":"hcr-dropdown--top-1-6-0","hcr-dropdown--left":"hcr-dropdown--left-1-6-0","hcr-dropdown--right":"hcr-dropdown--right-1-6-0"}};

var bemDropdown = Bem('dropdown', styles);
var bemItem = Bem('dropdown-item', styles);
var Dropdown = function Dropdown(_ref) {
  var active = _ref.active,
      children = _ref.children,
      extraClasses = _ref.extraClasses,
      links = _ref.links,
      onToggle = _ref.onToggle,
      position = _ref.position,
      xPosition = _ref.xPosition,
      yPosition = _ref.yPosition,
      rest = _objectWithoutProperties(_ref, ["active", "children", "extraClasses", "links", "onToggle", "position", "xPosition", "yPosition"]);

  var _useState = useState(active),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1]; // @todo: rethink this when forwardref is required


  var containerRef = useRef();
  useEffect(function () {
    onToggle(isActive);
  }, [isActive]); // closes dropdown

  var dropdownClose = function dropdownClose() {
    setIsActive(false);
  }; // opens dropdown


  var dropdownOpen = function dropdownOpen() {
    setIsActive(true);
  }; // toggles between closing and opening depending on the current state


  var dropdownToggle = function dropdownToggle() {
    if (!isActive) {
      dropdownOpen();
    } else {
      dropdownClose();
    }
  };

  var handleDropdownClick = function handleDropdownClick() {
    dropdownToggle();
  };

  var handleDropdownBlur = function handleDropdownBlur(e) {
    var origin = e.relatedTarget;
    if (origin && containerRef.current && containerRef.current.contains(origin)) return;
    dropdownClose();
  };

  var handleKeyDown = function handleKeyDown(event) {
    var SPACE_KEY = 32;
    var ENTER_KEY = 13;
    var ESC_KEY = 27; // Toggle dropdown state with space bar and enter keys

    if (event.keyCode === SPACE_KEY || event.keyCode === ENTER_KEY) {
      event.preventDefault(); // disable page scroll when space bar is triggered

      dropdownToggle();
    } // hiding dropdown if ESC is pressed


    if (event.keyCode === ESC_KEY) {
      dropdownClose();
    }
  };

  return (// @todo this should probably be a button,
    // though this requires button styles reset on a core side.
    React.createElement("div", _extends({
      className: bemDropdown.b({
        active: isActive,
        left: position === 'left' || xPosition === 'left',
        // @todo remove `position` in 2.0
        right: position === 'right' || xPosition === 'right',
        // @todo remove `position` in 2.0
        top: yPosition === 'top'
      }, extraClasses)
    }, rest, {
      onClick: handleDropdownClick,
      onBlur: handleDropdownBlur,
      onKeyDown: handleKeyDown,
      role: "button",
      tabIndex: "0",
      ref: containerRef
    }), children, React.createElement("ul", {
      className: bemDropdown.e('items')
    }, links.map(function (_ref2, i) {
      var text = _ref2.text,
          href = _ref2.href,
          key = _ref2.key,
          RouterLink = _ref2.RouterLink,
          linkRest = _objectWithoutProperties(_ref2, ["text", "href", "key", "RouterLink"]);

      return React.createElement("li", {
        className: bemItem.b(),
        key: key || "".concat(text, " + ").concat(i)
      }, RouterLink ? React.createElement(RouterLink, _extends({
        to: href,
        className: bemItem.e('link'),
        activeClassName: bemItem.m({
          active: true
        }, bemItem.e('link'))
      }, linkRest), text) : React.createElement("a", _extends({
        className: bemItem.e('link'),
        href: href
      }, linkRest), text));
    })))
  );
};
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = {
  active: false,
  extraClasses: '',
  onToggle: function onToggle() {},
  position: 'center',
  xPosition: 'center',
  yPosition: 'bottom'
};
Dropdown.propTypes = {
  /** Shows/hides dropdown */
  active: PropTypes.bool,

  /** Element that triggers dropdown */
  children: PropTypes.element.isRequired,

  /** Injection in className */
  extraClasses: PropTypes.string,

  /** List of links to display in a dropdown */
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.node,
    href: PropTypes.string,
    key: PropTypes.string,
    RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object])
  })).isRequired,

  /** Provides custom onToggle callback for dropdown wrapper
   * accepts boolean "isActive" as param */
  onToggle: PropTypes.func,

  /** Controls dropdown horizontal positioning
   * @deprecated will be removed in 2.0 */
  position: PropTypes.oneOf(['center', 'left', 'right']),

  /** Controls dropdown horizontal positioning */
  xPosition: PropTypes.oneOf(['center', 'left', 'right']),

  /** Controls dropdown vertical positioning */
  yPosition: PropTypes.oneOf(['top', 'bottom'])
};
var dropdown = Injecss(Dropdown, styles);

export { dropdown as Dropdown };
